import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sidebar-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sidebar-header" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "SCL Weltcup")
], -1)
const _hoisted_3 = { class: "sidebar-navitems" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "sidebar-navitems sidebar-subnavitems" }
const _hoisted_7 = { class: "sidebar-footer" }
const _hoisted_8 = { class: "appversion" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", null, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", {
          class: _normalizeClass(["navitem", { 'active': _ctx.activeRouteName == 'dashboard' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activatedSub = ''))
        }, [
          _createVNode(_component_router_link, { to: "/home" }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: "svgicon",
                innerHTML: _ctx.icons.dashboard
              }, null, 8, _hoisted_4),
              _createTextVNode(_toDisplayString(_ctx.$t("route.dashboard")), 1)
            ]),
            _: 1
          })
        ], 2),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              class: _normalizeClass(["navitem", { 'active': _ctx.activeRouteName == 'member' || _ctx.activeParentRouteName == 'member' || _ctx.activatedSub == 'member'}])
            }, [
              _createElementVNode("span", {
                class: "navitem",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openSubNav('member')))
              }, [
                _createElementVNode("i", {
                  class: "svgicon",
                  innerHTML: _ctx.icons.members
                }, null, 8, _hoisted_5),
                _createTextVNode(_toDisplayString(_ctx.$t("route.member")), 1)
              ]),
              _createElementVNode("ul", _hoisted_6, [
                _createElementVNode("li", {
                  class: _normalizeClass(["navitem", { 'active': _ctx.activeRouteName == 'memberlist' }])
                }, [
                  _createVNode(_component_router_link, { to: "/admin/member/list" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("route.memberlist")), 1)
                    ]),
                    _: 1
                  })
                ], 2),
                _createElementVNode("li", {
                  class: _normalizeClass(["navitem", { 'active': _ctx.activeRouteName == 'import' }])
                }, [
                  _createVNode(_component_router_link, { to: "/admin/member/import" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("route.import")), 1)
                    ]),
                    _: 1
                  })
                ], 2),
                _createElementVNode("li", {
                  class: _normalizeClass(["navitem", { 'active': _ctx.activeRouteName == 'export' }])
                }, [
                  _createVNode(_component_router_link, { to: "/admin/member/export" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("route.export")), 1)
                    ]),
                    _: 1
                  })
                ], 2)
              ])
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.appVersion), 1)
    ])
  ]))
}